import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import './index.css';
import App from './App';

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: 'us-east-2_onDIG2wZN',
            userPoolClientId: '2smo5n94bq5cd2ahua3b4q4gqj',
            region: 'us-east-2',
        }
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);